import { cx } from 'cva';
import { forwardRef, type ReactNode } from 'react';
import { PrivacyDisclaimer } from '../PrivacyDisclaimer/PrivacyDisclaimer';
import { SetScroll } from '../SetScroll/SetScroll';
import { Footer } from './Footer/Footer';
import { Header } from './Header/Header';
import styles from './Layout.module.css';

export type LayoutProps = {
  children?: ReactNode;
  className?: string;
  padded?: boolean;
  showPrivacyDisclaimer?: boolean;
};

export const Layout = forwardRef<HTMLDivElement, LayoutProps>(
  ({ children, className, padded = false, showPrivacyDisclaimer }, ref) => {
    return (
      <div className={cx(styles.root, className)} ref={ref}>
        <SetScroll />
        <Header />
        <div className={cx(padded && styles.padded)}>{children}</div>
        {showPrivacyDisclaimer && (
          <PrivacyDisclaimer className={styles.alignBottom} />
        )}
        <Footer />
      </div>
    );
  },
);

Layout.displayName = 'Layout';
